module.exports = __webpack_public_path__ + "img/Global Variable.599a8299.svg";